<template>
  <div class="container">
    <p><strong>Code Value: {{ codeValue }} </strong></p>
    <div class="qr-container">
      <qrcode-vue :value="codeValue" :size="200" level="H"></qrcode-vue>
      <h4>Instructions</h4>
      <div class="row">
        <div class="col">
          <p>Click "Generate New Code" button</p>
          <p>Scan QR code below from your mobile device's native camera or in OneApp'.</p>
          <p>Watch magic happen</p>
        </div>
      </div>
    </div>
    <div class="py-3" style="text-align: center">
      <button class="ty-button" v-on:click="generate">Generate New Code</button>
    </div>

  </div>
</template>

<script>
  import QrcodeVue from 'qrcode.vue'

  export default {
  name: 'QrGenerator',
  data: function() {
    return{
      deepURL:'https://toyota-one.app.link/smartlink?$user_code=',
      codeValue: ''
    }
  },
  props: {
    msg: String
  },
    components: {
      QrcodeVue
    },
  methods: {
    generate: function () {
      // this.axios.get('https://us-central1-tmna-onescan.cloudfunctions.net/api/generate-code').then((response) => {
      //   this.codeValue = response.data.user_code
      // }).catch((e) => {
      //   console.log(e);
      //   this.codeValue = "1234"
      // })
      this.axios.post('https://login.test.forgerock-login.com/oauth2/realms/tmna/device/code?response_type=token&scope=profile&client_id=oneapp',{
        headers: {
          'Host': 'login.test.forgerock-login.com',
          'Content-Type':'application/x-www-form-urlencoded'
        },
      }).then((response) => {
        const userCodeURL = 'https://login.test.forgerock-login.com/oauth2/realms/root/realms/tmna/device/user?user_code='+response.data.user_code;
        this.codeValue = userCodeURL;
      }).catch(() => {
        this.codeValue = "Error"
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  body{
    font-family: ToyotaType-Regular;
  }
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .ty-button{
    background: #D92429;
    border-radius: 0px;
    width:343px;
    height:64px;
    font-family: ToyotaType-Semibold;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0.73px;
    text-align: center;
  }
  .qr-container{
    padding-top:40px;
    text-align: center;
    height: 300px;
    /*background-color: #4281ff;*/
    height:540px;
  }
</style>
